/* eslint-disable @typescript-eslint/no-unused-vars */
import { Card, CardBody, Col, Container, Input, Label, Row } from 'reactstrap'
import DataTable, { TableColumn } from "react-data-table-component";
// import CollapseFilterData from './CollapseFilterData';
import { useEffect, useMemo, useState } from 'react';
import { SearchTableButton } from '../../../../utils/Constant';
import api from '../../../../utils/api';
import Swal from 'sweetalert2';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
} from "reactstrap";
import { RechargeAmountTableDataColumnType } from '../../../../Types/Application/Ecommerce/Ecommerce';
import RechargeListFilterHeader from './RechargeListFilterHeader';
import { RechargeAmountTableAction, RechargeAmountTableOfferComponent } from '../../../../Types/Application/Ecommerce/RechargeList';
import { SVG } from '../../../../AbstractElements';

const RechargeListContainer = () => {
  const [filterText, setFilterText] = useState("");
  const [RfidCardListTableDatas, setRfidCardListTableDatas] = useState<RechargeAmountTableDataColumnType[]>([]);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editData, setEditData] = useState<any>(null);

  // Pagination-related states
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [loading, setLoading] = useState(false);
  const fetchCardLists = async (page: number, size: number) => {
    try {
      setLoading(true);

      const response = await api.get(
        `api/CardRechargeMaster/GetAllRechargeAmountPagination?pageNumber=${page}&pageSize=${size}`
      );

      if (response.status === 200) {
        setRfidCardListTableDatas(
          response.data.items.map((item: { cardRechargeMasterId: any; cardAmount: any }) => ({
            cardRechargeMasterId: item.cardRechargeMasterId,
            cardAmount: item.cardAmount,
          }))
        );

        // Set total record count from backend
        setTotalRows(response.data.totalCount);
      }
    } catch (error) {
      console.error("Failed to fetch Recharge amount list:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCardLists(currentPage, pageSize);
  }, [currentPage, pageSize]);

  const handleDelete = async (id: number) => {
    try {
      await api.delete(`/api/CardRechargeMaster/DeleteRechargeAmount?rechargeAmountId=${id}`);
      Swal.fire('Deleted!', 'Record has been deleted.', 'success');

      // Refresh current page data
      await fetchCardLists(currentPage, pageSize);
    } catch (error) {
      Swal.fire('Error!', 'Failed to delete the record.', 'error');
      console.error("Delete error:", error);
    }
  };

  // Edit

  const handleEdit = (row: any) => {
    setEditData(row);
    setEditModalOpen(true);
  };

  const handleEditChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEditData({ ...editData, [e.target.name]: e.target.value });
  };

  const handleEditSave = async () => {
    try {
      if (!editData || !editData.cardRechargeMasterId || !editData.cardAmount) {
        Swal.fire("Error!", "Please fill all fields before saving.", "error");
        return;
      }
      if (isNaN(Number(editData.cardAmount)) || Number(editData.cardAmount) <= 0) {
        Swal.fire("Error!", "Please enter a valid recharge amount.", "error");
        return;
      }
      await api.put(`/api/CardRechargeMaster/UpdateRechargeAmount`, {
        cardRechargeMasterId: editData.cardRechargeMasterId,
        cardAmount: editData.cardAmount,

      });

      // Refresh current page data
      await fetchCardLists(currentPage, pageSize);

      setEditModalOpen(false);
      Swal.fire("Updated!", "The Recharge has been updated.", "success");
    } catch (error) {
      Swal.fire("Error!", "Failed to update the Recharge.", "error");
    }
  };

  const RechargeAmountListTableDataColumn: TableColumn<RechargeAmountTableDataColumnType>[] = [
    {
      name: "Amount",
      cell: (row) => <RechargeAmountTableOfferComponent title={String(row.cardAmount)} />,
      sortable: true,
      grow: 2,
    },
    // {
    // name: "Action",
    // cell: (row) => <RechargeAmountTableAction cardRechargeMasterId={row.cardRechargeMasterId} onDelete={handleDelete} />,
    // },

    {
      name: "Action",
      cell: (row) => (
        <div className="d-flex align-items-center gap-2">
          <span
            onClick={() => handleEdit(row)}
            title="Edit"
            style={{ cursor: "pointer" }}
          >
            <SVG
              iconId="edit-content"
              style={{ fill: "blue", width: 18, height: 18 }}
            />
          </span>
          <span
            onClick={() => handleDelete(Number(row.cardRechargeMasterId))}
            title="Delete"
            style={{ cursor: "pointer" }}
          >
            <SVG
              iconId="trash1"
              style={{ fill: "red", width: 18, height: 18 }}
            />
          </span>
        </div>
      ),
    },
  ];

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  const handlePerRowsChange = (newPerPage: number, page: number) => {
    setPageSize(newPerPage);
    setCurrentPage(page);
  };

  const filteredItems = RfidCardListTableDatas.filter((item: any) =>
    Object.values(item)
      .join(' ')
      .toLowerCase()
      .includes(filterText.toLowerCase())
  );

  const subHeaderComponentMemo = useMemo(() => {
    return (
      <div className="dataTables_filter d-flex align-items-center">
        <Label className="me-2">{SearchTableButton}:</Label>
        <Input onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFilterText(e.target.value)} type="search" value={filterText} />
      </div>
    );
  }, [filterText]);

  return (
    <Container fluid>
      <Row>
        <Col sm="12">
          <Card>
            <CardBody>
              <div className="list-product-header">
                <RechargeListFilterHeader />
                {/* <CollapseFilterData /> */}
              </div>
              <div className="list-product">
                <div className="table-responsive">
                  <DataTable
                    data={filteredItems}
                    columns={RechargeAmountListTableDataColumn}
                    striped
                    highlightOnHover
                    pagination
                    paginationServer
                    paginationTotalRows={totalRows}
                    onChangePage={handlePageChange}
                    onChangeRowsPerPage={handlePerRowsChange}
                    paginationDefaultPage={currentPage}
                    paginationPerPage={pageSize}
                    progressPending={loading}
                    selectableRows
                    subHeader
                    subHeaderComponent={subHeaderComponentMemo}
                  />
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Modal
        isOpen={editModalOpen}
        toggle={() => setEditModalOpen(!editModalOpen)}
      >
        <ModalHeader toggle={() => setEditModalOpen(!editModalOpen)}>
          Edit Recharge Amount
        </ModalHeader>
        <ModalBody>
          {editData && (
            <>
              <FormGroup>
                <Label>Recharge Amount</Label>
                <Input
                  name="cardAmount"
                  value={editData.cardAmount}
                  onChange={handleEditChange}
                />
              </FormGroup>

            </>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setEditModalOpen(false)}>
            Cancel
          </Button>
          <Button color="primary" onClick={handleEditSave}>
            Save
          </Button>
        </ModalFooter>
      </Modal>
    </Container>
  )
}

export default RechargeListContainer